var map = {
	"./doc.png": 372,
	"./file.png": 131,
	"./jpg.png": 1875,
	"./json-file.png": 1876,
	"./mp4.png": 374,
	"./pdf.png": 373,
	"./png.png": 1877,
	"./svg.png": 1878,
	"./txt.png": 1879
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1874;


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype ^\.\/.*\.png$
// module id = 1874
// module chunks = 0